import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useAppEx, TbViewProvider, useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { Table, WebBasicLayouts } from '@ow/ditto'
import { dealLayoutSlugs } from '@ow/ditto-core'
import Pagination from '../container/pagination'
import ContainerRender from '../container/container-render'

const fileterSystemFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter((field) => {
    return field && !['system'].includes(field.group) && !field.hidden
  })
}

// 提取到core
const dealQueris = (queries, fields, userInfo) => {
  return (queries || []).map((v) => {
    if (v.value && v.value.includes('userInfo')) {
      const arr = v.value.split('.')
      const obj = fields.find((f) => f.slug === v.slug)
      if (obj && arr && arr.length > 1) {
        return { ...v, value: userInfo[arr[1]] }
      }
      return v
    }
    return v
  })
}

const elements = [
  {
    type: 'boxing',
    leftElements: [],
    rightElements: [
      {
        type: 'linkButton',
        actionType: 'collector',
      },
    ],
  },
  // {
  //   type: 'unboxing',
  //   elements: [
  //     {
  //       type: 'list',
  //       actionType: 'listConfig',
  //     },
  //   ],
  //   footerElement: {
  //     type: 'unboxing',
  //     leftElements: [],
  //     rightElements: [
  //       {
  //         type: 'pagination',
  //       },
  //     ],
  //   },
  // },
]
const RefTable = ({
  filters,
  selectedObjectIds = [],
  multiple,
  onChange,
  inline,
  setRefSelectedIds,
  finnalRefSelectedIds,
}) => {
  const { userInfoInApp } = useAppEx()
  const datas = useRef([])
  const {
    tbSlug,
    id,
    tbData = [],
    fields,
    selectedIds,
    setFilters,
    setSelectedIds,
    fetchTbData,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbSlug',
      'id',
      'fields',
      'tbData',
      'selectedIds',
      'setFilters',
      'setSelectedIds',
      'fetchTbData',
    ])
  )
  console.log(tbSlug, 'tbSlugtbSlugtbSlug')

  const showFields = useMemo(() => {
    return fileterSystemFields(fields)
  }, [fields])

  const config = useMemo(() => {
    const arr = showFields.map((v) => {
      return { slug: v.slug, showType: 'show' }
    })
    return { fields: arr }
  }, [showFields])

  useEffect(() => {
    datas.current = tbData
  }, [tbData])
  useEffect(() => {
    // 初始化
    if (selectedObjectIds && selectedObjectIds.length) {
      console.log({ selectedObjectIds })
      setSelectedIds(selectedObjectIds)
    }
    if (finnalRefSelectedIds) {
      setSelectedIds(
        multiple
          ? finnalRefSelectedIds.map((x) => x.objectId)
          : [finnalRefSelectedIds.objectId]
      )
    }
  }, [])

  useEffect(() => {
    const { queries = [] } = filters || {}
    const _queries = dealQueris(queries, fields, userInfoInApp)
    const hasIsFakeDeleted = fields.find((v) => v.slug === 'isFakeDeleted')
    if (hasIsFakeDeleted) {
      setFilters(
        {
          logicType: 'and',
          queries: [
            {
              slug: 'current',
              value: true,
              queryType: ['notEqual'],
            },
            ..._queries,
          ],
        },
        true
      )
    } else if (fetchTbData) {
      fetchTbData()
    }
  }, [id])

  const updateValues = (ids, _tbData) => {
    if (onChange) {
      const arr = _tbData.filter((v) => ids.includes(v.objectId))
      const values = multiple ? arr : arr[0]
      if (!inline) {
        setRefSelectedIds(values)
      } else {
        onChange(values)
      }
    }
  }

  return (
    <div className="w-full flex-1 overflow-hidden flex flex-col items-end justify-between">
      <div className="flex-1 h-full w-full overflow-hidden flex flex-col">
        {(elements || [])
          .filter((element) => !element.hidden)
          .map((element, i) => {
            if (
              ![
                'gaofengxianxiangqing_3d2afd56_f5b9_443e_99fe_6042aee98f46',
                'weixianzuoyeyiju_253f9ef4_e6da_4825_ad1f_bce2ac3c06b9',
              ].includes(tbSlug)
            ) {
              return (
                <ContainerRender key={`${element}-${i}`} layouts={element} />
              )
            }
            return null
          })}
        <div className="flex-1 h-full w-full overflow-hidden">
          <Table
            fields={fields}
            tbData={tbData}
            isShowSelections
            selectedIds={selectedIds || selectedObjectIds}
            config={config}
            isRenderOperateTable={false}
            onChangeSelected={(ids) => {
              if (multiple) {
                if (ids === 'all') {
                  const arr = tbData.map((v) => v.objectId)
                  setSelectedIds(arr)
                  updateValues(arr, datas.current)
                } else {
                  setSelectedIds(ids)
                  updateValues(ids, datas.current)
                }
              } else if (ids && ids.length && ids !== 'all') {
                setSelectedIds([ids[0]])
                updateValues([ids[0]], datas.current)
              }
            }}
          />
        </div>
      </div>
      <Pagination />
    </div>
  )
}

const RefWebBasicLayouts = ({ layouts, onChange, tbId, opts, data }) => {
  const formRef = useRef(null)
  const { fields } = useTbViewStore((state) => pick(state, ['fields']))
  const [detailData, setDetailData] = useState(null)

  const { getDitto } = useAppEx()

  useEffect(() => {
    onChange(formRef)
  }, [])

  useEffect(() => {
    if (data) {
      const ditto = getDitto(tbId)
      ditto.fetchById(data[opts.slug]).then((itemData) => {
        setDetailData(itemData)
      })
    }
  }, [])

  if (data && data[opts.slug] && !detailData) {
    return null
  }
  return (
    <div className="relative w-full flex-1 overflow-hidden flex flex-col items-end justify-between">
      <WebBasicLayouts
        fields={fields}
        isReCreate
        editableSlugs={dealLayoutSlugs(layouts)}
        layouts={layouts}
        originalData={detailData}
        forbidRefresh
        ref={formRef}
      />
    </div>
  )
}

const Ref = function ({
  tbId,
  value,
  filters,
  layouts,
  selectedObjectIds,
  multiple,
  opts,
  data,
  onChange,
  inline,
  setRefSelectedIds,
  finnalRefSelectedIds,
}) {
  const { appId } = useAppEx()
  if (!tbId) {
    return null
  }
  return (
    <TbViewProvider appId={appId} tbId={tbId} vid={null}>
      {layouts ? (
        <RefWebBasicLayouts
          layouts={layouts}
          onChange={onChange}
          value={value}
          tbId={tbId}
          opts={opts}
          data={data}
        />
      ) : (
        <RefTable
          filters={filters}
          selectedObjectIds={selectedObjectIds}
          multiple={multiple}
          onChange={onChange}
          inline={inline}
          setRefSelectedIds={setRefSelectedIds}
          finnalRefSelectedIds={finnalRefSelectedIds}
        />
      )}
    </TbViewProvider>
  )
}
export default Ref
